<script>

    import { shipmentStore } from '../stores'

    import NumeralMethods from '../$methods/numeral.methods'

    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'

</script>

{#if $shipmentStore}

    <InfoCard subtitle="Paquete">
        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            {#if $shipmentStore.order.package.width}
                <InfoField label="Ancho" icon="fas fa-ruler-horizontal" value="{ $shipmentStore.order.package.width } cm" />
            {/if}
            {#if $shipmentStore.order.package.height}
                <InfoField label="Alto" icon="fas fa-ruler-vertical" value="{ $shipmentStore.order.package.height } cm" />
            {/if}
            {#if $shipmentStore.order.package.length}
                <InfoField label="Largo" icon="fas fa-ruler" value="{ $shipmentStore.order.package.length } cm" />
            {/if}
            <InfoField label="Peso" icon="fas fa-weight-hanging" value="{ $shipmentStore.order.package.weight } kg" />
            <InfoField label="Volumétrico" icon="fas fa-weight" value="{ $shipmentStore.order.package.volumetric } kg" />
            <InfoField label="Valor" icon="fas fa-dollar-sign" value={ NumeralMethods.cash($shipmentStore.order.package.value) } />
            <InfoField label="Descripción" icon="fas fa-align-left" size="full" value={ $shipmentStore.order.package.content || 'Sin descripción' } />
        </div>
    </InfoCard>

{/if}
